import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {LangsListParamsService} from "@store/langs-list-params.service";
import {fuseAnimations} from "../../../@fuse/animations";

@Component({
    selector: 'app-ask-for-lang',
    templateUrl: './ask-for-lang.component.html',
    animations: fuseAnimations,
    styleUrls: ['./ask-for-lang.component.scss'],
    standalone: false
})
export class AskForLangComponent implements OnInit {

  flagCodes: any;

  constructor(
    public langsListParamsService: LangsListParamsService,
    private cdr: ChangeDetectorRef,
  ) {

    this.langsListParamsService.waitingForAvailableLang$.subscribe((waiting) => {

      // console.log('[AskForLangComponent] waiting', waiting, this.langsListParamsService.availableLangs$.value);
      // this.cdr.markForCheck();
      // this.cdr.detectChanges();

    });

  }

  ngOnInit(): void {

    // this.langsListParamsService.langChoosedIsDisplayed$.next(true);

    // Set the country iso codes for languages for flags
    this.flagCodes = {
      'en': 'us',
      'fr': 'fr',

    };

  }

  // trackByFn(index: number, item: any): any {
  //   return item.id || index;
  // }


  setActiveLang(id: string) {
    this.langsListParamsService.setLangFromAsk(id);
  }

}
